<div class="flex flex-col max-w-160 md:min-w-160 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>


    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="siteMeasurementForm">
        <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>

        <div class="w-full md:mb-0 pb-3">
            <span class="mb-2 font-medium">Type</span>
            <mat-radio-group class="flex" [color]="'primary'" [formControlName]="'type'">
                <mat-radio-button *ngIf="reportType !== 'FlatOrOfficeOrShop' && selectedType != 'BuiltUp'"
                    value="Land Area">Land Area</mat-radio-button>
                <mat-radio-button *ngIf="reportType === 'FlatOrOfficeOrShop'" value="Carpet Area">Carpet
                    Area</mat-radio-button>
                <mat-radio-button *ngIf="reportType !== 'FlatOrOfficeOrShop' && selectedType != 'Land'"
                    value="Builtup Area">Builtup Area</mat-radio-button>
            </mat-radio-group>
        </div>
        <mat-form-field>
            <mat-label>Particular</mat-label>
            <input type="text" matInput [formControl]="siteMeasurementForm.get('particular')" #particularInput
                [matAutocomplete]="autoParticular">
            <mat-autocomplete #autoParticular="matAutocomplete" [displayWith]="displayOptionsFn(options)">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
                    {{option.name}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Width (In.Ft)</mat-label>
            <input matInput [formControlName]="'width'" [value]="siteMeasurementForm.get('width').value" type="number"
                class="text-right">
        </mat-form-field>
        <mat-form-field>
            <mat-label>Depth (In.Ft)</mat-label>
            <input matInput [formControlName]="'depth'" [value]="siteMeasurementForm.get('depth').value" type="number"
                class="text-right">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Total (In.Sq.Ft)</mat-label>
            <input matInput [formControlName]="'total'" type="number" class="text-right">
        </mat-form-field>
        <!-- Actions -->
        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>

            <div class="flex items-center mt-4 sm:mt-0">
                <div class="flex ">
                    <button class="order-first sm:order-last" *ngIf="siteMeasurement && siteMeasurement.id > 0"
                        mat-flat-button [color]="'primary'" (click)="updateAndClose()">
                        Update
                    </button>
                    <button class="order-first sm:order-last " *ngIf="!siteMeasurement" mat-flat-button
                        [disabled]="!siteMeasurementForm.valid" [color]="'primary'" (click)="saveAndNew()">
                        Save & New
                    </button>
                </div>
                <div class="flex pl-2">
                    <button class="order-first sm:order-last" *ngIf="!siteMeasurement" mat-flat-button
                        [disabled]="!siteMeasurementForm.valid" [color]="'primary'" (click)="saveAndClose()">
                        Save & Close
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>